/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState_container = [
    {
        id: '',
        il_ocean_import_hbl_id: '',
        cntr_number: '',
        volume: '',
        pierpass: '',
        delivery_order: '',
        delivery_order_link: '',
        trucker_name: '',
        proof: '',
        proof_link: '',
        proof_date: null,
        perdiem: null,
        empty_date: null,
        empty: '',
        pickup_number: '',
    },
];

const oimContainerUpdateSlice = createSlice({
    name: 'oimContainerUpdateForm',
    initialState: initialState_container,
    reducers: {
        setContainerFormData: (state, action) => {
            return action.payload;
        },
        addContainer: (state, action) => {
            addUniqueById(state, action.payload);
        },
        deleteContainer: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((container) => container.id !== idToDelete);
        },
        setContainerUpdateData: (state, action) => {
            const { id, newData } = action.payload;
            return state.map((item) => {
                if (item.id === id) {
                    return { ...item, ...newData };
                }
                return item;
            });
        },
    },
});

export const { setContainerFormData, addContainer, deleteContainer, setContainerUpdateData } =
    oimContainerUpdateSlice.actions;
export default oimContainerUpdateSlice.reducer;
